import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Switch } from '../ui/switch';
import { Label } from '../ui/label';
import { BarChart3, AlertCircle } from 'lucide-react';

export const MatchStatsSection = ({
  timelineAutoStats,
  setTimelineAutoStats
}) => {
  return (
    <Card data-testid="match-stats-settings-card">
      <CardHeader>
        <CardTitle className="text-xl font-semibold font-title flex items-center gap-2">
          <BarChart3 className="w-5 h-5 text-emerald-600" strokeWidth={1.5} />
          Match Statistics
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between p-4 rounded-xl bg-gray-50 border border-gray-200">
          <div className="flex items-start gap-3">
            <div className="p-2 bg-emerald-100 rounded-lg text-emerald-600">
              <BarChart3 className="w-5 h-5" strokeWidth={1.5} />
            </div>
            <div className="flex-1">
              <Label htmlFor="timeline-auto-stats" className="text-base font-medium text-gray-900 cursor-pointer">
                Auto-record stats from timeline
              </Label>
              <p className="text-sm text-gray-500 mt-1">
                Automatically calculate player stats (goals, assists, cards, minutes played) from match events when you save a match
              </p>
            </div>
          </div>
          <Switch
            id="timeline-auto-stats"
            checked={timelineAutoStats}
            onCheckedChange={setTimelineAutoStats}
            className="data-[state=checked]:bg-emerald-600"
            data-testid="timeline-auto-stats-toggle"
          />
        </div>
        
        {/* Advisory message */}
        {timelineAutoStats && (
          <div className="flex items-start gap-3 p-4 rounded-xl bg-amber-50 border border-amber-200">
            <AlertCircle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" strokeWidth={1.5} />
            <div>
              <p className="text-sm font-medium text-amber-800">
                Auto-stats enabled
              </p>
              <p className="text-sm text-amber-700 mt-1">
                When this is on, saving a match will automatically update player statistics based on timeline events. 
                Stats include: goals, assists, yellow cards, red cards, starts, sub appearances, and minutes played. 
                You can still manually adjust stats on the Stats tab if needed.
              </p>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default MatchStatsSection;
